import { EmployeeFormPage } from '@personnel/presentation/components/shared';

/**
 * Role Create Page
 *
 * Page for creating a new role.
 * Wrapper component that delegates to RoleFormPage with mode='create'.
 * Route: /roles/create
 *
 * @returns {React.ReactElement} Role create page component
 *
 * @example
 * // In router
 * <Route path="/employees/create" component={EmployeeCreatePage} />
 */
export const EmployeeCreatePage = (): React.ReactElement => {
  return <EmployeeFormPage mode="create" submitLabel={'Create'} />;
};
